import { useState, type ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';
import { useClaimBill } from '../billing/useClaimBill.js';
import { useBusinessNumber } from '../../../../shared/hooks/useBusinessNumber.js';

export function RateValidationPage(): ReactNode {
  const { t } = useTranslation();

  const { decimal } = useBusinessNumber();
  const { claimId } = useParams<{ claimId: string }>();
  const { token } = useAuth();
  const { bill, error: claimError } = useClaimBill(`/v1/approval/claim/${claimId}`);
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [form, setForm] = useState({ lineId: '', rateMasterRate: '', contractRate: '', appliedRate: '' });

  const handleValidate = async () => {
    try {
      const r = await apiRequest<any>('/v1/approval/rate-validation/', {
        token, method: 'POST',
        body: { claimId, lineId: form.lineId, rateMasterRate: Number(form.rateMasterRate), contractRate: Number(form.contractRate), appliedRate: Number(form.appliedRate) },
      });
      setResult(r);
    } catch (e) { setError((e as Error).message); }
  };

  return (
    <div style={{ padding: 24 }}>
      <h1>{t('fa.rate.title', { bill })}</h1>
      {(error ?? claimError) && <p style={{ color: 'red' }}>{error ?? claimError}</p>}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, maxWidth: 500, marginBottom: 16 }}>
        {[{ k: 'lineId', l: t('fa.rate.lineId') }, { k: 'rateMasterRate', l: t('fa.rate.masterRate'), t: 'number' }, { k: 'contractRate', l: t('fa.rate.contractRate'), t: 'number' }, { k: 'appliedRate', l: t('fa.rate.appliedRate'), t: 'number' }].map(f => (
          <label key={f.k}>{f.l}<br /><input type={f.t ?? 'text'} value={(form as any)[f.k]} onChange={e => setForm({ ...form, [f.k]: e.target.value })} style={{ width: '100%', padding: 6, borderRadius: 4, border: '1px solid var(--color-border-default)' }} /></label>
        ))}
      </div>
      <button onClick={handleValidate} style={{ padding: '8px 24px', background: 'var(--color-text-link)', color: 'var(--color-text-inverse)', border: 'none', borderRadius: 6, cursor: 'pointer' }}>{t('fa.rate.validateBtn')}</button>
      {result && (
        <div style={{ marginTop: 16, padding: 16, border: '1px solid var(--color-border-default)', borderRadius: 8 }}>
          <strong>{t('fa.rate.result')}</strong> <span style={{ color: result.validationResult === 'PASS' ? 'var(--color-success)' : 'var(--color-danger)' }}>{result.validationResult}</span>
          <span>{t('fa.rate.sourceMismatch', { source: String(result.rateSource), pct: decimal(result.mismatchPct) })}</span>
        </div>
      )}
    </div>
  );
}
